<template>
    <div>
        <div class="results-top d-flex flex-wrap align-items-center justify-content-between justify-content-lg-start mb-2 mb-lg-3">
            <small class="flex-basis-100 flex-basis-lg-auto mb-2 mb-lg-0">
                {{ pageCount }} {{ $t('category.of') }} {{ resultsTotal }}
            </small>

            <div class="form-group form-group-results form-group-no-label d-flex align-items-center ml-lg-3">
                <label for="country" class="text-nowrap mr-2 hidden-until-lg">
                    {{ $t('category.products_per_page') }}:
                </label>
                <select
                    v-model="query.limit"
                    @change="handleFilter"
                    id="page_limit"
                    class="form-control form-control-results-select form-control-select"
                    aria-hidden="true"
                >
                    <option value="9">9</option>
                    <option value="18">18</option>
                    <option value="36">36</option>
                    <option value="72">72</option>
                </select>
            </div>

            <div class="form-group form-group-results form-group-no-label d-flex align-items-center ml-lg-auto">
                <label for="country" class="text-nowrap mr-2 hidden-until-lg">
                    {{ $t('category.sort_by') }}:
                </label>
                <select
                    v-model="query.sort"
                    @change="handleFilter"
                    id="sort"
                    class="form-control form-control-results-select form-control-select"
                    aria-hidden="true"
                >
                    <option value="popular">{{ $t('category.popular') }}</option>
                    <option value="asc">{{ $t('category.price_lowest') }}</option>
                    <option value="desc">{{ $t('category.price_highest') }}</option>
                </select>
            </div>
        </div>

        <template v-if="isLoading">
            <slot name="loader" />
        </template>

        <div v-else>
            <slot v-if="results.length" name="results" />
            <slot v-else name="results-empty" />

            <pagination v-if="results.length" />
        </div>
    </div>
</template>

<script>
    import { ContentLoader } from 'vue-content-loader';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import Pagination from '@/_vue/components/ui/pagination';

    export default {
        name: 'Results',
        components: {
            ContentLoader,
            Pagination,
        },
        data() {
            return {
                debouncer: null,
            };
        },
        computed: {
            ...mapState('filters', {
                originalQuery: 'query',
                isLoading: 'isLoading',
                results: 'results',
                resultsTotal: 'resultsTotal',
            }),

            ...mapGetters('filters', {
                pageCount: 'pageCount',
            }),
        },
        methods: {
            ...mapActions('filters', [
                'getResults',
                'resetFilters',
            ]),

            ...mapMutations('filters', [
                'updateQuery',
            ]),

            cloneQuery() {
                this.query = JSON.parse(JSON.stringify(this.originalQuery));
            },

            handleFilter() {
                clearTimeout(this.debouncer);

                this.debouncer = setTimeout(() => {
                    this.query.page = 1;
                    this.updateQuery(this.query);
                    this.getResults();
                }, 300);
            },
        },
        watch: {
            originalQuery: {
                handler: 'cloneQuery',
                immediate: true,
            },
        },
    };
</script>
